import script from "./ChatStatusMsg.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatStatusMsg.vue?vue&type=script&setup=true&lang=js"

import "./ChatStatusMsg.vue?vue&type=style&index=0&id=6786c238&lang=scss"

const __exports__ = script;

export default __exports__